import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector, getFormValues } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import ContentCardFooter from '../common/template/contentCardFooter';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Button from '../common/button/button';
import Form from '../common/form/form';
import LabelAndInput from '../common/form/labelAndInput';
import LabelAndInputNumber from '../common/form/labelAndInputNumber';
import LabelAndInputMask from '../common/form/labelAndInputMask';
import LabelAndInputDateTime from '../common/form/labelAndInputDateTime';
import Select from '../common/form/select';
import SelectAlteracao from '../common/form/selectAlteracao';
import { setError } from '../common/toast/toast';
import imagemAdd from '../assets/images/icone_add_imagem.png';

import {
	setModoTela, initForm
} from './reportsArquivoActions';
import ClipboardImageHandler from '../common/form/ClipboardImageHandler';

class ReportsArquivoForm extends Component {

	state = {

	}

	componentDidMount() {

	}

    componentWillMount() {

    }

    render() {

		let readOnly = this.props.excluir ? 'readOnly' : '';

        return (
			<ContentCard>
				<Form event={this.props.handleSubmit}>
					<ContentCardBody>
						<Row>

							<Grid cols='12 12 12 12'>
								<ClipboardImageHandler
									label='Use Ctrl+V para colar ou arraste e solte anexos aqui.'
									msgErro='Selecione apenas (.PDF, .XLSX, .XLS, .DOC, .DOCX, .XML, .PPT, .PPTX, .PNG, .JPG e .JPEG)'
									types={[
										'application/pdf',
										'application/xml',
										'text/xml',
										'text/plain',
										'application/msword',
										'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
										'application/vnd.ms-excel',
										'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
										'application/vnd.ms-powerpoint',
										'application/vnd.openxmlformats-officedocument.presentationml.presentation',
										'image/png',
										'image/jpg',
										'image/jpeg'
									]}
									onChange={result => {
										this.props.initForm({
											...this.props.formularioValues,
											arquivo_base64: result ? result.base64 : null,
											nome: result ? result.filename : null
										});
									}} />
							</Grid>
						</Row>
						<Row style={{ marginTop: 16 }}>
							<Field
								name='nome'
								component={LabelAndInput}
								label='Nome' placeholder='Informe o nome'
								cols='12 12 12 12'
								readOnly={readOnly} />

							<Field
								name='legenda'
								component={LabelAndInput}
								label='Legenda' placeholder='Informe a legenda'
								cols='12 12 12 12'
								readOnly={readOnly} />
						</Row>
					</ContentCardBody>
					<ContentCardFooter>
						<Row alignCenter>
							<Grid cols='6 6 4 3'>
								{this.props.excluir ? (
									<Button
										text='Excluir'
										submit type={'danger'}
										icon={'fa fa-trash'} />
								) : (
								<Button
									text='Salvar'
									submit
									type={'success'}
									icon={'fa fa-check'} />
								)}
							</Grid>
							<Grid cols='6 6 4 3'>
								<Button
									text='Voltar'
									type={'warning'}
									icon={'fa fa-chevron-left'}
									event={() => this.props.setModoTela('lista')} />
							</Grid>
						</Row>
					</ContentCardFooter>
				</Form>
			</ContentCard>
        )
    }


}

ReportsArquivoForm = reduxForm({form: 'reportsArquivoForm', destroyOnUnmount: false})(ReportsArquivoForm);
const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	formularioValues: getFormValues('reportsArquivoForm')(state),
	registro: state.reportsArquivo.registro
});
const mapDispatchToProps = dispatch => bindActionCreators({
	setModoTela, initForm
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(ReportsArquivoForm);
